<div class="modal-header">
  <h5 class="modal-title">{{ title | translate }}</h5>
  <button
    id="form-modal-close-button"
    type="button"
    class="btn-close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="dismiss()"
  >
  </button>
</div>
<form
  [formGroup]="form"
  (ngSubmit)="validate()"
>
  <div class="modal-body">
    <h6>{{ text | translate }}</h6>
    <div
      *ngFor="let field of formDefinition"
      class="mb-3"
    >
      <label class="form-label">{{ field.label | translate }}</label>
      <input
        *ngIf="field.type === 'text'"
        type="text"
        class="form-control"
        [formControlName]="field.name"
      />
      <textarea
        *ngIf="field.type === 'textarea'"
        class="form-control"
        [formControlName]="field.name"
      ></textarea>
      <pod-validation-messages
        [model]="form.get(field.name)"
        fieldName="{{field.label | translate}}"
      ></pod-validation-messages>
    </div>
  </div>
  <div class="modal-footer">
    <button
      id="form-modal-cancel-button"
      type="button"
      class="btn btn-secondary"
      data-dismiss="modal"
      (click)="dismiss()"
    >{{ 'Close' | translate }}</button>
    <button
      id="form-modal-submit-button"
      type="submit"
      class="btn btn-primary"
    >{{ 'Submit' | translate }}</button>
  </div>
</form>